import { Block } from "@block";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { StackActions, useNavigation } from "@react-navigation/core";
import { spacing } from "@styles/spacing";
import { InputText } from "app/shared/components/form/input";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
// import { Constant } from "app/shared/constant/constant";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { globalShowFuture } from "app/shared/util/future";
import { getTwoCharacterFromName } from "app/shared/util/validate";
import moment from "moment";
import * as React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet } from "react-native";
import { Avatar, Button, useTheme } from "react-native-paper";
import { useSelector } from "react-redux";
import { getUserProfileSelector } from "../reducer/selectors";
import { getIDTypeArray, ItemIDType, loadIDTypeJson } from "./infomation-utils";

interface InformationAccountData {
  user: string;
  username: string;
  mobilePhone: string;
  identityPapers: string;
  dateOfIssue: string;
  address: string;
  sex: string;
  identityPapersNumber: string;
  addressIssue: string;
  email: string;
  authorizationType: string;
}

const InformationAccount = () => {
  const { colors } = useTheme();
  const { t, i18n } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const { dispatch, reset } = useNavigation();
  const { control, setValue } = useForm<InformationAccountData>({
    defaultValues: {
      user: "",
      username: "",
      mobilePhone: "",
      identityPapers: "",
      dateOfIssue: "",
      address: "",
      sex: "",
      identityPapersNumber: "",
      addressIssue: "",
      email: "",
      authorizationType: "",
    },
    mode: "onChange",
  });

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    reset({
      index: 1,
      routes: [{ name: ScreenNameType.HOME }, { name: ScreenNameType.LIST_ACCOUNT_MANAGEMENT }],
    });
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        goHome();
      },
    },
    {
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      onPressSubtitle: () => {
        goManager();
      },
    },
    {
      name: t("COMMON_THONG_TIN_TAI_KHOAN"),
      onPressSubtitle: () => {},
    },
  ];

  // Lấy userprofile from selector

  const userProfile = useSelector(getUserProfileSelector);

  const [image, setImage] = React.useState<any>(null);
  const [idTypeArray, setIDTypeArray] = React.useState<ItemIDType[]>([]);

  const textInputProps: object = {
    editable: false,
    multiline: true,
  };

  // Styles Component
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: { flex: 1 },
        textInput: {
          color: colors.accent,
          backgroundColor: colors.backgroundForm,
          fontWeight: "700",
          textShadowColor: "black",
          fontSize: 13,
        },
        buttonContainer: { width: 128, alignSelf: "center", backgroundColor: colors.notification },
        acceptButtonContainer: { width: 128, alignSelf: "center" },
      }),
    [colors],
  );

  const getGender = React.useCallback(
    (gender: string): string => {
      if (gender.toLowerCase().trim() === "male") {
        return t("ACC_GIOI_TINH_NAM");
      } else {
        return t("ACC_GIOI_TINH_NU");
      }
    },
    [t],
  );

  const getIDType = React.useCallback(
    (value?: string): string => {
      let nameType: string = "";
      if (value?.length) {
        nameType = value;
        if (idTypeArray?.length) {
          const filters: ItemIDType[] = idTypeArray.filter((item: ItemIDType) => {
            return value === item.CODE;
          });
          if (filters?.length) {
            nameType = i18n.language === "vi" ? filters[0].NAME.vi : filters[0].NAME.en;
          }
        }
      }
      return nameType;
    },
    [i18n.language, idTypeArray],
  );

  const pickImage = async () => {
    // let result = await ImagePicker.launchImageLibraryAsync({
    //   mediaTypes: ImagePicker.MediaTypeOptions.All,
    //   allowsEditing: true,
    //   aspect: [4, 3],
    //   quality: 1,
    // });

    // console.log("pickImage: ", result);

    // if (!result.cancelled) {
    //   setImage(result.uri);
    // }
    globalShowFuture();
  };

  const FormAvatar = (
    <Block w={isDesktop ? 200 : "100%"} center middle ph={spacing.medium}>
      <StackSpacing size="huge" />
      <Block center>
        <>
          {!image && <Avatar.Text label={getTwoCharacterFromName(userProfile?.FULLNAME)} size={72} />}
          {image && <Avatar.Image size={72} source={{ uri: image }} />}
        </>
      </Block>
      <StackSpacing size="medium" />
      <Block center>
        <Button
          onPress={pickImage}
          uppercase={false}
          labelStyle={{ letterSpacing: 0, color: colors.whiteText, fontSize: 12 }}
          style={{ borderRadius: 24, minWidth: 136 }}
          mode="contained"
          color={colors.accent}>
          {t("ACC_THAY_ANH_DAI_DIEN")}
        </Button>
      </Block>
    </Block>
  );

  const FormRow = ({ nameLeft = "", labelLeft = "", nameRight = "", labelRight = "" }) => (
    <Block row={isDesktop ? true : false}>
      <Block flex={isDesktop ? 1 : undefined} bottom>
        <InputText name={nameLeft} control={control} style={styles.textInput} inputProps={textInputProps} label={labelLeft} />
      </Block>
      <QueueSpacing size={"huge"} />
      <Block flex={isDesktop ? 1 : undefined} bottom>
        <InputText name={nameRight} control={control} style={styles.textInput} inputProps={textInputProps} label={labelRight} />
      </Block>
      <QueueSpacing size={"huge"} />
    </Block>
  );

  const FormAccount = (
    <Block row={isDesktop ? true : false}>
      {FormAvatar}
      <Block pv={spacing.huge} flex={1} ph={isDesktop ? spacing.small : spacing.medium}>
        <FormRow nameLeft="user" labelLeft={t("ACC_TEN_DANG_NHAP")} nameRight="username" labelRight={t("COMMON_HO_TEN")} />
        <FormRow nameLeft="mobilePhone" labelLeft={t("ACC_DIEN_THOAI")} nameRight="sex" labelRight={t("ACC_GIOI_TINH")} />
        <FormRow
          nameLeft="identityPapers"
          labelLeft={t("ACC_GIAY_TO_TUY_THAN")}
          nameRight="identityPapersNumber"
          labelRight={t("ACC_SO_GIAY_TO")}
        />
        <FormRow nameLeft="dateOfIssue" labelLeft={t("ACC_NGAY_CAP")} nameRight="addressIssue" labelRight={t("ACC_DIA_CHI_NOI_CAP")} />
        <FormRow nameLeft="email" labelLeft={t("ACC_EMAIL")} nameRight="address" labelRight={t("ACC_DIA_CHI")} />

        {/* <FormRow nameLeft="email" labelLeft={t("ACC_EMAIL")} nameRight="authorizationType" labelRight={t("ACC_KIEU_XAC_THUC")} />
        <InputText name={"address"} control={control} style={styles.textInput} inputProps={textInputProps} label={t("ACC_DIA_CHI")} /> */}
      </Block>
    </Block>
  );

  const ButtonHome = (
    <Button style={{ alignSelf: "center" }} color={colors.accent} mode="contained" onPress={goHome}>
      {t("FUNC_TRANG_CHU")}
    </Button>
  );

  React.useEffect(() => {
    if (!userProfile) {
      return;
    }
    const { IDNUMBER, ADDRESS, FULLNAME, GENDER, IDDATE, CELLPHONE, IDPLACE, IDTYPE, EMAIL, CIFNUMBER } = userProfile;
    const gender = getGender(String(GENDER));

    setValue("user", String(CIFNUMBER));
    setValue("username", String(FULLNAME));
    setValue("sex", gender);
    setValue("mobilePhone", String(CELLPHONE));
    setValue("identityPapers", getIDType(IDTYPE));
    setValue("identityPapersNumber", String(IDNUMBER));
    if (IDDATE && IDDATE?.length > 0) setValue("dateOfIssue", moment(String(IDDATE), "YYYYMMDD").format("DD/MM/YYYY"));
    setValue("addressIssue", String(IDPLACE));
    setValue("address", String(ADDRESS));
    setValue("email", String(EMAIL));
  }, [getGender, setValue, t, userProfile, idTypeArray, getIDType]);

  React.useEffect(() => {
    loadIDTypeJson().then(() => {
      setIDTypeArray(getIDTypeArray());
    });
  }, []);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("COMMON_THONG_TIN_TAI_KHOAN")} subtitles={subtitlesArrays} />
        <Block pb={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <Block br={12} w100 bg={colors.backgroundForm}>
            {FormAccount}
          </Block>
        </Block>
        {ButtonHome}
        <StackSpacing size="huge" />
      </ScrollView>
    </Block>
  );
};

export default InformationAccount;
